var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 47,
    viewBox: "0 0 49 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8398 23.6973H41.4765",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8194 21.1191H41.8672V27.0714H47.8194V21.1191Z",
    fill: "url(#paint0_linear_2727_210)",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8194 8.61914H41.8672V14.5714H47.8194V8.61914Z",
    fill: "url(#paint1_linear_2727_210)",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8194 33.6191H41.8672V39.5714H47.8194V33.6191Z",
    fill: "url(#paint2_linear_2727_210)",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0938 11.5957H41.4771",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0938 36.5938H41.4771",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4385 29.4805V39.2481C33.4385 39.4627 33.4385 39.6009 33.4385 39.9616C33.4385 43.2969 26.1786 46.0006 17.2232 46.0006C8.26765 46.0006 1.00781 43.2968 1.00781 39.9616C1.00781 39.6011 1.00791 39.5634 1.00791 39.2481V29.4805",
    fill: "#EBF5FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4385 29.4805V39.2481C33.4385 39.4627 33.4385 39.6009 33.4385 39.9616C33.4385 43.2969 26.1786 46.0006 17.2232 46.0006C8.26765 46.0006 1.00781 43.2968 1.00781 39.9616C1.00781 39.6011 1.00791 39.5634 1.00791 39.2481V29.4805",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4385 18.5176V28.2852C33.4385 28.4998 33.4385 28.638 33.4385 28.9987C33.4385 32.334 26.1786 35.0378 17.2232 35.0378C8.26765 35.0378 1.00781 32.334 1.00781 28.9987C1.00781 28.6382 1.00791 28.6005 1.00791 28.2852V18.5176",
    fill: "#EBF5FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4385 18.5176V28.2852C33.4385 28.4998 33.4385 28.638 33.4385 28.9987C33.4385 32.334 26.1786 35.0378 17.2232 35.0378C8.26765 35.0378 1.00781 32.334 1.00781 28.9987C1.00781 28.6382 1.00791 28.6005 1.00791 28.2852V18.5176",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4385 7.51172V17.2793C33.4385 17.4939 33.4385 17.6321 33.4385 17.9928C33.4385 21.3281 26.1786 24.0319 17.2232 24.0319C8.26765 24.0319 1.00781 21.3281 1.00781 17.9928C1.00781 17.6323 1.00791 17.5946 1.00791 17.2793V7.51172",
    fill: "#EBF5FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4385 7.51172V17.2793C33.4385 17.4939 33.4385 17.6321 33.4385 17.9928C33.4385 21.3281 26.1786 24.0319 17.2232 24.0319C8.26765 24.0319 1.00781 21.3281 1.00781 17.9928C1.00781 17.6323 1.00791 17.5946 1.00791 17.2793V7.51172",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2153 13.0783C26.1707 13.0783 33.4305 10.3745 33.4305 7.03914C33.4305 3.70381 26.1707 1 17.2153 1C8.25982 1 1 3.70381 1 7.03914C1 10.3745 8.25982 13.0783 17.2153 13.0783Z",
    fill: "#EBF5FF",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2727_210",
    x1: 41.8672,
    y1: 21.1191,
    x2: 47.8194,
    y2: 27.0714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2561"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2727_210",
    x1: 41.8672,
    y1: 8.61914,
    x2: 47.8194,
    y2: 14.5714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2561"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2727_210",
    x1: 41.8672,
    y1: 33.6191,
    x2: 47.8194,
    y2: 39.5714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2561"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDb);
export default __webpack_public_path__ + "static/media/Db.76b50c652a9340b34aff18911846a175.svg";
export { ForwardRef as ReactComponent };